export const ROUTES = {
  HOME: "/home",
  LOGIN: "/login",
  SIGNUP: "/signup",
  ADDPAKAT: "/addpakat",
  INQUIRY: "/inquiry",
  BUY_PACKET_NUMBER: "/buyPacketNumber",
  NOTHING: "*",
};
